import { IonContent, IonPage } from '@ionic/react';
import RecentActivityContainer from '../../components/home/RecentActivityContainer';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { HomeMessages } from '../../intl/HomeMessages';
import LinkCardList from 'src/components/home/LinkCardList';
import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import { DqDivider } from 'src/components/DqDivider';
import { JobSyncSlide } from 'src/components/job-sync-slide/JobSyncSlide';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

const HomePage: FC = () => {
  document.title = englishOnlyIntl.formatMessage(HomeMessages.home);
  useGA4();

  const intl = useIntl();

  return (
    <IonPage>
      <DesktopHeader title={intl.formatMessage(HomeMessages.home)} />
      <IonContent>
        <JobSyncSlide />
        <div className="ion-margin-top ion-margin-bottom">
          <DqDivider title={intl.formatMessage(HomeMessages.recentActivity)} />
        </div>

        <RecentActivityContainer />

        <div className="ion-margin-top ion-margin-bottom">
          <DqDivider title={intl.formatMessage(HomeMessages.homeStoneAgeResourcesTitle)} />
        </div>
        <LinkCardList />
      </IonContent>
    </IonPage>
  );
};

export default HomePage;
